module.exports = __webpack_public_path__ + "media/images/flags/fr-95747314b9532ecac2cfc045921ac218.svg";